import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class NoteService {
  url=ConfigService.toApiUrl("notes/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-by-state")}/${state}`,ConfigService.addAction('list'));
  }
  getByComposition(compositionId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-by-composition")}/${compositionId}`,ConfigService.addAction('list'));
  }
  getAverage(paccId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-by-average")}/${paccId}/${periodId}`,ConfigService.addAction('list'));
  }
  getAverageAll(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-by-average-all")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }

  
  getStudentTotalAverage(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-by-student-total-all")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }
  storeFollowUp(ressource:any){
    return this.http.post<any>(`${ConfigService.toApiUrl("notes-follow-up")}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }


  getStudentNoteByPeriods(periodId:any,studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-students-by-periods")}/${periodId}`,ConfigService.addAction('list'));

    } else {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("notes-students-by-periods")}/${periodId}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }
}
